// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"style-module--logoWrapper--NTSM6","responsive":"style-module--responsive--1v59p","small":"style-module--small--3nXkz","medium":"style-module--medium--sU2i-"};